import { call, put } from 'redux-saga/effects';

import { saveWorkflowDraft } from 'api/WorkflowsAPI';
import { addNegativeToastWithErrorId, addPositiveToast } from 'modules/toastContainer';
import { parseWorkflowForSaving } from '../../utils';
import { SaveWorkflowDraftRequestAction, actions } from '../actions';

export default function* saveWorkflowDraftSaga(action: SaveWorkflowDraftRequestAction) {
  const errorMessage = `Error saving journey draft. Please try again later.`;

  try {
    yield put(actions.updateIsAsyncLoading(true));
    const { workflow, goToWorkflow, onSuccess } = action.payload;
    const updatedWorkflow = parseWorkflowForSaving(workflow);
    const { data, errors } = yield call(saveWorkflowDraft, updatedWorkflow);
    if (errors?.length) {
      yield put(actions.saveWorkflowError());
      yield put(addNegativeToastWithErrorId(errorMessage, 'saveWorkflowDraftSaga'));
      return;
    }

    const { saveWorkflowDraft: savedWorkflow } = data;
    const { nodes = [] } = savedWorkflow;
    yield put(actions.updateHasUnsavedChanges(false));
    yield put(
      actions.saveWorkflowDraftResponse({ ...savedWorkflow, nodes }, { shouldValidateNodes: true }),
    );
    if (goToWorkflow) {
      const { id: workflowId, workflowType } = goToWorkflow;
      yield put(actions.fetchWorkflowRequest(workflowId, workflowType, true));
    } else {
      yield put(actions.updateIsAsyncLoading(false));
    }
    yield put(addPositiveToast('Journey draft saved'));

    if (onSuccess) {
      yield call(onSuccess);
    }
  } catch (error) {
    yield put(actions.updateIsAsyncLoading(false));
    yield put(actions.saveWorkflowError());
    yield put(addNegativeToastWithErrorId(errorMessage, 'saveWorkflowDraftSaga'));
  }
}
